/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lvs-box[_ngcontent-%COMP%]{background-color:#fff;color:#828282;padding:25px 30px 30px;width:450px}.lvs-box[_ngcontent-%COMP%]   .lvs-box-header-title[_ngcontent-%COMP%]{border-bottom:1px solid #828282;font-size:1.2rem}.lvs-box[_ngcontent-%COMP%]   .lvs-box-title[_ngcontent-%COMP%]{font-size:1.6rem;letter-spacing:normal;margin:20px 0}.lvs-box[_ngcontent-%COMP%]   .lvs-box-chat-now[_ngcontent-%COMP%]{margin-top:10px}"];
export { styles as styles };
//# sourceMappingURL=live-agent-support.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/header/live-agent-support/live-agent-support.component.scss.shim.ngstyle.js
// module id = 1467
// module chunks = 27 28 29